module.exports = function (Component) {
  Component.options.__i18nFiles = Component.options.__i18nFiles || []
  Component.options.__i18nFiles.push('components/modal/DiscountModal')
  delete Component.options._Ctor
}
